type ActiveBoardUser = {
	id: string;
	activeNode?: string;
};

export const getChangedActiveNodeIds = (
	previousUsers: ActiveBoardUser[],
	nextUsers: ActiveBoardUser[]
): Set<string> => {
	const previousByUser = new Map(previousUsers.map((user) => [user.id, user.activeNode] as const));
	const nextByUser = new Map(nextUsers.map((user) => [user.id, user.activeNode] as const));
	const changedNodeIds = new Set<string>();

	for (const userId of new Set([...previousByUser.keys(), ...nextByUser.keys()])) {
		const previousUid = previousByUser.get(userId);
		const nextUid = nextByUser.get(userId);
		if (previousUid === nextUid) continue;
		if (previousUid) changedNodeIds.add(previousUid);
		if (nextUid) changedNodeIds.add(nextUid);
	}

	return changedNodeIds;
};
